/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgContact } from '../../models/svg-contact';

export interface GetSvgContactBySvgId$Params {
  svgId: number;
}

export function getSvgContactBySvgId(http: HttpClient, rootUrl: string, params: GetSvgContactBySvgId$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgContact>> {
  const rb = new RequestBuilder(rootUrl, getSvgContactBySvgId.PATH, 'get');
  if (params) {
    rb.path('svgId', params.svgId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SvgContact>;
    })
  );
}

getSvgContactBySvgId.PATH = '/svgcontact/{svgId}';
